import type {
  ComboBoxOption,
  ComboBoxOptions
} from "@dealer-center/core-components";
import {
  ComboBox,
  type InterstateOnChangeEvent
} from "@dealer-center/core-components";
import type {
  LocaleYearMakeData,
  LocaleYearMakeRequest,
  ModelLocale,
  SearchResponse
} from "@dealer-center/inventory-pages-gvm-interface";
import {
  comboBoxValue,
  localeComboBoxValue,
  valueFromComboBox,
  valuesToComboBoxOptions
} from "../util/comboBoxHelper";

const localesToOptions = (
  locales: ModelLocale[] | undefined
): ComboBoxOption[] => {
  if (!locales) {
    return [];
  }
  return locales.map(item => ({
    value: item.locale,
    label: item.display
  }));
};

interface LocaleYearMakeFiltersProps {
  queryData: SearchResponse<LocaleYearMakeData>;
  localeYearMakeRequest: LocaleYearMakeRequest;
  setLocaleYearMakeRequest: (data: LocaleYearMakeRequest) => void;
  resettableProps: Record<string, any>;
}

export const LocaleYearMakeFilters = ({
  queryData,
  localeYearMakeRequest,
  setLocaleYearMakeRequest,
  resettableProps
}: LocaleYearMakeFiltersProps) => {
  const isQueryError = !!queryData.error;
  const locales = localesToOptions(queryData.data?.locales);
  const years = valuesToComboBoxOptions(queryData.data?.years);
  const makes = valuesToComboBoxOptions(queryData.data?.makes);
  const selectedLocale = localeComboBoxValue(
    queryData.data?.locales,
    localeYearMakeRequest.locale
  );
  const selectedYear = comboBoxValue(localeYearMakeRequest.year);
  const selectedMake = comboBoxValue(localeYearMakeRequest.make);

  const handleInputChange = (
    event: InterstateOnChangeEvent<ComboBoxOptions>
  ) => {
    const name = event.target.name || "";
    const selectedOption = event.target.value;

    let dependentAttr = {};

    if (name === "make") {
      dependentAttr = resettableProps;
    }

    const value = valueFromComboBox(selectedOption);

    setLocaleYearMakeRequest({
      ...localeYearMakeRequest,
      [name]: value && name === "year" ? Number(value) : value,
      ...dependentAttr
    });
  };

  return (
    <>
      <ComboBox
        name="locale"
        options={locales}
        placeholder="Select Locale"
        value={selectedLocale}
        onChange={handleInputChange}
      />
      <ComboBox
        name="year"
        options={years}
        placeholder="Select Year"
        value={selectedYear}
        onChange={handleInputChange}
      />
      <ComboBox
        name="make"
        options={makes}
        placeholder="Select Make"
        value={selectedMake}
        onChange={handleInputChange}
      />
    </>
  );
};
